import { FC, Fragment, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import {
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  EllipsisHorizontalIcon,
} from "@heroicons/react/20/solid";

import { appointmentsStatus, views } from "../../../types/calendar";
import { Button, Input, Modal } from "antd";
import AddAppointmentModalWrapper from "./addAppointment/AddAppointmentModalWrapper";
import { useDispatch, useSelector } from "react-redux";
import { setDate, setView } from "../../../services/store/slices/calender";
import { DatePicker } from "antd/lib";
import dayjs from "dayjs";
import arLocale from "antd/es/date-picker/locale/ar_EG";
import enLocale from "antd/es/date-picker/locale/en_US";
import { GiSettingsKnobs } from "react-icons/gi";
import { CgAddR } from "react-icons/cg";
import { weekEnd, weekStart } from "../../../utils/DateUtils";
import { useIntl } from "react-intl";

interface CalendarHeaderProps {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  dateAndTime: {
    date: Date | null;
    startTime: string | null;
    finishTime: string | null;
  };
  setDateAndTime: React.Dispatch<
    React.SetStateAction<{
      date: Date | null;
      startTime: string | null;
      finishTime: string | null;
    }>
  >;
  setSearchFilter: React.Dispatch<React.SetStateAction<string | null>>;
  setStatusFilter: React.Dispatch<
    React.SetStateAction<appointmentsStatus | null>
  >;
}
function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}
const CalendarHeader: FC<CalendarHeaderProps> = ({
  isModalOpen,
  setIsModalOpen,
  dateAndTime,
  setDateAndTime,
  setSearchFilter,
  setStatusFilter,
}) => {
  const [appointmentStatus, setAppointmentStatus] =
    useState<appointmentsStatus | null>(null);
  const dispatch = useDispatch();
  const { date, view, currentLang } = useSelector(
    (state: {
      calendar: { date: Date; view: views };
      user: { currentLang: "en" | "ar" };
    }) => {
      return {
        date: new Date(state.calendar.date),
        view: state.calendar.view,
        currentLang: state.user.currentLang,
      };
    }
  );

  const views = {
    // month: currentLang === "ar" ? "عرض شهري" : "Month View",
    day: currentLang === "ar" ? "عرض يومي" : "Day View",
    week: currentLang === "ar" ? "عرض أسبوعي" : "Week View",
  } as const;
  const handleChangeView = (view: views) => {
    dispatch(setView(view));
  };
  const changeDate = (changeType: "next" | "prev") => {
    // const newDate = date;
    const newDate = date;
    if (view === "week") {
      if (changeType === "next") {
        newDate.setDate(date.getDate() + 7);
      } else if (changeType === "prev") {
        newDate.setDate(date.getDate() - 7);
      }
    }
    // if (view === "month") {
    //   if (changeType === "next") {
    //     newDate.setMonth(date.getMonth() + 1);
    //   } else if (changeType === "prev") {
    //     newDate.setMonth(date.getMonth() - 1);
    //   }
    // }
    if (view === "day") {
      if (changeType === "next") {
        newDate.setDate(date.getDate() + 1);
      } else if (changeType === "prev") {
        newDate.setDate(date.getDate() - 1);
      }
    }
    dispatch(setDate(new Date(newDate)));
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleChangeStatusFilter = (status: appointmentsStatus | null) => {
    setStatusFilter(status);
    setAppointmentStatus(status);
  };
  const appointmentStatusMenu = [
    { key: null, en: "All", ar: "الكل" },
    // { key: "pending", en: "Pending", ar: "معلقة" },
    // { key: "arrived", en: "Arrived", ar: "مُنتظر التنفيذ" },
    { key: "created", en: "Pending", ar: "موعد قادم" },
    { key: "started", en: "On Progress", ar: "قيد التنفيذ" },
    // { key: "no_show", en: "Didn't attend", ar: "العميل لم يظهر" },
    { key: "completed", en: "Completed", ar: "مكتمل" },
    { key: "canceled", en: "Canceled", ar: "ملغي" },
  ] as const;

  const onChangeDatePicker = (value: any) => {
    dispatch(setDate(new Date(value?.format("YYYY-MM-DD") || "")));
  };

  const weekFormat = "MM/DD";
  const intl = useIntl();
  return (
    <header className="bg-[#F2F3FA] rounded-md flex flex-none items-center justify-between border-b border-gray-200 px-6 py-4">
      <h1 className="text-base font-semibold leading-6 text-gray-900">
        <time dateTime="2022-01">
          {date.toLocaleString(currentLang === "en" ? "en" : "ar", {
            month: "short",
          }) +
            " " +
            date?.getFullYear()}
        </time>
      </h1>

      <div className="flex items-center ">
        <div className="hidden md:ml-4 md:flex md:items-center  gap-x-4 ">
          <Menu as="div" className="relative ">
            <Menu.Button
              type="button"
              className="flex items-center border-none gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
              // style={{ fontFamily: "Cairo" }}
            >
              {/* {view} */}
              {views[view]}
              <ChevronDownIcon
                className="-mr-1 h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </Menu.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 z-10 mt-3 w-36 origin-top-right overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="py-1">
                  <Menu.Item>
                    {({ active }: any) => (
                      <a
                        href="#"
                        className={classNames(
                          view === "day"
                            ? "bg-gray-100 text-gray-900 my-1"
                            : "text-gray-700",
                          "block px-4 py-2 text-sm"
                        )}
                        onClick={() => handleChangeView("day")}
                      >
                        {views.day}
                      </a>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }: any) => (
                      <a
                        href="#"
                        className={classNames(
                          view === "week"
                            ? "bg-gray-100 text-gray-900 my-1"
                            : "text-gray-700",
                          "block px-4 py-2 text-sm"
                        )}
                        onClick={() => handleChangeView("week")}
                      >
                        {views.week}{" "}
                      </a>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
          <div className="relative   flex items-center rounded-md bg-white shadow-sm md:items-stretch">
            <div
              className="pointer-events-none absolute inset-0 rounded-md ring-1 ring-inset ring-gray-300"
              aria-hidden="true"
            />
            <button
              type="button"
              className="flex border-none items-center bg-white justify-center rounded-r-md py-2 pl-4 pr-3 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:px-2 md:hover:bg-gray-50"
              onClick={() => changeDate("prev")}
            >
              <span className="sr-only">Next week</span>
              {currentLang === "ar" ? (
                <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
              ) : (
                <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
              )}
            </button>

            <DatePicker
              locale={currentLang === "en" ? enLocale : arLocale}
              onChange={onChangeDatePicker}
              picker={view === "day" ? "date" : view}
              value={dayjs(date)}
              size="large"
              allowClear={false}
              variant="borderless"
              format={
                view === "week"
                  ? (value: any) => {
                      // return `${dayjs(value)
                      //   .startOf("week")
                      //   .subtract(1, "days")
                      //   .format(weekFormat)} ~ ${dayjs(value)
                      //   .endOf("week")
                      //   .subtract(1, "days")
                      //   .format(weekFormat)}`;

                      return `${dayjs(weekStart(value)).format(
                        weekFormat
                      )} ~ ${dayjs(weekEnd(value)).format(weekFormat)}`;
                    }
                  : "YYYY-MM-DD"
              }
            />

            <button
              type="button"
              className="flex border-none items-center bg-white justify-center rounded-l-md py-2 pl-3 pr-4 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:px-2 md:hover:bg-gray-50"
              onClick={() => changeDate("next")}
            >
              <span className="sr-only">Previous week</span>
              {currentLang === "en" ? (
                <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
              ) : (
                <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
              )}
            </button>
            <span className="relative -mx-px h-5 w-px bg-gray-300 md:hidden" />
          </div>
          <div className="flex inp-search-radius">
            <Input.Search
              // className=" rounded-s-lg rounded-e-lg !rounded-lg"
              // rootClassName=" !rounded-lg"
              style={{ borderRadius: "30px " }}
              placeholder={intl.formatMessage({ id: "searchByClientOrApp" })}
              onSearch={(value) => setSearchFilter(value)}
              onChange={(e: any) => {
                setSearchFilter(e.target.value);
              }}
            />

            <Menu as="div" className="relative mx-1 self-center ">
              <Menu.Button
                type="button"
                className="flex h-10   items-center border-none gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                style={{ fontFamily: "Cairo" }}
              >
                <GiSettingsKnobs size={20} color="#555" className="rotate-90" />
              </Menu.Button>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 z-10 mt-3 w-36 origin-top-right overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="py-1">
                    {appointmentStatusMenu.map(
                      (
                        status: {
                          key: appointmentsStatus | null;
                          en: string;
                          ar: string;
                        },
                        index
                      ) => (
                        <Menu.Item key={index}>
                          <Button
                            type="text"
                            htmlType="button"
                            block
                            onClick={() => handleChangeStatusFilter(status.key)}
                            className={classNames(
                              appointmentStatus === status.key
                                ? "bg-gray-100 text-gray-900 my-1"
                                : "text-gray-700",
                              "block px-4 py-2 text-sm"
                            )}
                          >
                            {status[currentLang]}
                          </Button>
                        </Menu.Item>
                      )
                    )}
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
          </div>
          <div className="ml-6 h-6 w-px bg-gray-300" />
          <Button
            type="primary"
            htmlType="button"
            className="ml-6 flex items-center gap-2 rounded-md  px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            onClick={showModal}
          >
            <CgAddR size={20} />
            <span> {intl.formatMessage({ id: "newAppointment" })}</span>
          </Button>
          <Modal
            width={700}
            destroyOnClose={true}
            maskClosable={false}
            centered
            // style={{ top: -100 }}
            className="overflow-y-auto"
            // title="أضف حجز جديد"
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            // destroyOnClose
            footer=""
          >
            <AddAppointmentModalWrapper
              setIsModalOpen={setIsModalOpen}
              dateAndTime={dateAndTime}
              setDateAndTime={setDateAndTime}
            />
          </Modal>
        </div>

        <Menu as="div" className="relative ml-6 md:hidden">
          <Menu.Button className="-mx-2 flex items-center rounded-full border border-transparent p-2 text-gray-400 hover:text-gray-500">
            <span className="sr-only">Open menu</span>
            <EllipsisHorizontalIcon className="h-5 w-5" aria-hidden="true" />
          </Menu.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 z-10 mt-3 w-36 origin-top-right divide-y divide-gray-100 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="py-1">
                <Menu.Item>
                  {({ active }: any) => (
                    <a
                      href="#"
                      className={classNames(
                        active
                          ? "bg-gray-100 text-gray-900 my-1"
                          : "text-gray-700",
                        "block px-4 py-2 text-sm"
                      )}
                    >
                      Create event
                    </a>
                  )}
                </Menu.Item>
              </div>
              <div className="py-1">
                <Menu.Item>
                  {({ active }: any) => (
                    <a
                      href="#"
                      className={classNames(
                        active
                          ? "bg-gray-100 text-gray-900 my-1"
                          : "text-gray-700",
                        "block px-4 py-2 text-sm"
                      )}
                    >
                      Go to today
                    </a>
                  )}
                </Menu.Item>
              </div>
              <div className="py-1">
                <Menu.Item>
                  {({ active }: any) => (
                    <a
                      href="#"
                      className={classNames(
                        active
                          ? "bg-gray-100 text-gray-900 my-1"
                          : "text-gray-700",
                        "block px-4 py-2 text-sm"
                      )}
                    >
                      Day view
                    </a>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }: any) => (
                    <a
                      href="#"
                      className={classNames(
                        active
                          ? "bg-gray-100 text-gray-900 my-1"
                          : "text-gray-700",
                        "block px-4 py-2 text-sm"
                      )}
                    >
                      Week view
                    </a>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }: any) => (
                    <a
                      href="#"
                      className={classNames(
                        active
                          ? "bg-gray-100 text-gray-900 my-1"
                          : "text-gray-700",
                        "block px-4 py-2 text-sm"
                      )}
                    >
                      Month view
                    </a>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }: any) => (
                    <a
                      href="#"
                      className={classNames(
                        active
                          ? "bg-gray-100 text-gray-900 my-1"
                          : "text-gray-700",
                        "block px-4 py-2 text-sm"
                      )}
                    >
                      Year view
                    </a>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
    </header>
  );
};

export default CalendarHeader;
